// extracted by css-extract-rspack-plugin
export default {"wrapper":"F7iIm","title":"gRk3W"};